import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import * as fromModel from '../../services/models';
import { DataService } from '../../services/context/data.service';
import { RefDataService } from '../../services/context/ref-data.service';

@Component({
  selector: 'gp-pvfv-setting',
  templateUrl: './pvfv-setting.component.html',
  styleUrls: ['./pvfv-setting.component.scss']
})
export class PVFVSettingComponent implements OnInit {

  
  @Output() onChangeSetting: EventEmitter<any> = new EventEmitter();
  
  protected _storeDataSubscription: Subscription;

  
  @Input('ViewBy') viewBy:fromModel.PLANRESULTVIEWBY = fromModel.PLANRESULTVIEWBY.PV;

  constructor(private dataService: DataService,
    private refDataService: RefDataService,) { 
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
  }

  ngOnInit(): void {
    
  }

  private populateAppData(appData: fromModel.IAppData){
    if(appData && appData.action !== fromModel.DATA_ACTION.NONE){      
      this.viewBy = this.dataService.getPlanresultViewBy();
    }
  }

  onValChange(value){
    //this.dataService.dispatchAction(fromModel.DATA_ACTION.UPDATEPLANRESULTVIEWBY, "PVFVComponent-onValChange", value);
    this.onChangeSetting.emit(value);
  }

}
